import { Link } from 'react-router-dom';
import logo from '../images/logo_c_only192.png';

function Navbar() {
  return (
    <header className="sticky top-0 z-50 border-b border-border/40 bg-white/70 backdrop-blur-lg shadow-sm">
      <div className="mx-auto flex h-20 max-w-7xl items-center justify-between px-6 lg:px-8">
        <Link to="/" className="flex items-center gap-3 group">
          <div className="relative">
            <div className="absolute inset-0 bg-primary-500/20 blur-xl rounded-full group-hover:bg-primary-500/30 transition-all"></div>
            <img src={logo} alt="The Open Sperm Bank" className="h-10 w-10 relative z-10" />
          </div>
          <span className="font-semibold text-xl tracking-tight text-foreground hidden sm:block">The Open Sperm Bank</span>
        </Link>
        <nav className="flex items-center gap-2 lg:gap-3">
          <Link 
            to="/" 
            className="px-4 py-2 text-sm font-medium text-muted-foreground hover:text-foreground transition-colors rounded-lg hover:bg-secondary"
          >
            Home
          </Link>
          <Link 
            to="/contact" 
            className="px-4 py-2 text-sm font-medium text-muted-foreground hover:text-foreground transition-colors rounded-lg hover:bg-secondary"
          >
            Contact
          </Link>
          <Link 
            to="/donors" 
            className="ml-2 px-6 py-2.5 text-sm font-semibold text-white bg-gradient-to-r from-primary-600 to-primary-500 rounded-full hover:shadow-lg hover:scale-105 transition-all duration-200 shadow-md"
          >
            Find a Donor
          </Link>
        </nav>
      </div>
    </header>
  );
}

export default Navbar;
